module.exports = __webpack_public_path__ + "media/Audio17_j.068a8a73.wav";